var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNotAuthorized = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 458,
  height: 321,
  viewBox: "0 0 458 321",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M256.855 123.687C256.855 166.501 228.98 201.209 194.595 201.209C160.21 201.209 132.337 166.501 132.337 123.687C132.337 80.8724 160.21 46.1647 194.595 46.1647C228.98 46.1647 256.855 80.8724 256.855 123.687Z",
  fill: "#FCD6BE"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M124.499 85.4358C124.499 85.4358 122.758 61.2446 145.107 41.7657C147.734 48.7789 152.073 51.1911 152.073 51.1911C152.073 51.1911 166.005 32.0266 193.289 27.6288L192.999 35.7973C192.999 35.7973 215.929 22.9156 237.698 21.9732C239.73 39.8808 237.698 52.448 237.698 52.448L244.083 48.6774C244.083 48.6774 249.253 70.5669 251.312 91.6683C239.73 74.1255 225.507 65.3289 225.507 65.3289C205.77 73.8119 174.713 74.1255 174.713 74.1255C174.423 107.428 165.425 143.558 165.425 143.558L157.878 134.447C157.298 112.141 159.04 99.2591 147.719 98.6311C136.399 98.0031 130.884 138.531 148.3 143.558C148.3 156.439 154.446 179.382 160.225 188.332C143.366 182.201 132.336 154.868 132.336 154.868L127.402 163.665C127.402 163.665 108.825 137.903 118.695 109.941C114.308 115.283 112.019 115.596 112.019 115.596C112.019 115.596 107.664 97.3742 124.499 85.4358Z",
  fill: "#C99D66"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M189.411 11.1016C183.652 11.8361 177.498 12.7826 170.939 13.8233C115.502 22.6199 124.499 85.4364 124.499 85.4364C124.499 85.4364 141.717 84.5475 164.326 83.5688C164.642 56.4082 171.701 27.6673 189.411 11.1016Z",
  fill: "var(--color-primary)"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M189.411 11.1016C171.701 27.6673 164.642 56.4083 164.326 83.5688C192.054 82.3672 227.893 81.0311 250.042 81.0311C252.992 12.0342 232.338 5.62345 189.411 11.1016Z",
  fill: "#F5F5F5"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M148.182 84.2906C148.182 84.2906 178.486 71.6301 217.38 71.6301C242.913 71.6301 274.077 72.1714 292.473 75.5658C297.4 76.4744 297.054 84.2485 292.066 84.6141C264.288 86.65 207.083 90.4322 148.182 84.2906Z",
  fill: "var(--color-primary)"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M190.568 113.69L213.099 98.6102L218.433 103.677L217.344 116.283L198.296 126.061L190.568 113.69Z",
  fill: "white"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M231.072 114.986L251.312 100.142L257.616 104.501L256.855 110.509L236.718 126.768L230.078 120.472L231.072 114.986Z",
  fill: "white"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M250.355 122.203C248.556 124.19 246.022 125.156 242.609 125.156C239.218 125.156 236.695 124.19 234.896 122.202C230.835 117.714 231.006 108.769 231.109 103.426C231.112 103.304 231.128 103.204 231.147 103.131C234.786 101.473 243.697 98.5294 254.069 103.184C254.089 103.257 254.108 103.357 254.11 103.479C254.21 108.82 254.379 117.757 250.355 122.203ZM211.827 122.203C210.028 124.19 207.495 125.156 204.081 125.156C200.689 125.156 198.167 124.19 196.368 122.203C192.307 117.715 192.479 108.77 192.582 103.426C192.584 103.304 192.601 103.204 192.619 103.131C196.258 101.473 205.166 98.5304 215.542 103.184C215.561 103.257 215.579 103.357 215.581 103.48C215.682 108.819 215.851 117.756 211.827 122.203ZM260.203 103.343C260.15 100.583 258.793 98.1888 256.749 97.2455C243.786 91.2688 232.625 95.2335 228.427 97.2149C228.233 97.3074 228.046 97.413 227.866 97.5327C227.13 98.0188 226.253 98.23 225.424 97.9742C224.367 97.6482 223.3 97.5409 222.228 97.6664C221.807 97.7159 221.405 97.7992 221.025 97.9082C220.231 98.1351 219.404 97.9362 218.691 97.498C218.539 97.4048 218.382 97.3206 218.221 97.2455C205.259 91.2688 194.098 95.2335 189.9 97.2149C189.195 97.5484 188.578 98.0584 188.068 98.6963C187.392 99.5406 186.435 100.057 185.403 100.057H163.343C161.889 100.057 160.567 101.125 160.28 102.668C159.884 104.791 161.373 106.654 163.263 106.654H183.921C185.306 106.654 186.443 107.835 186.497 109.332C186.708 115.21 187.763 122.122 192.014 126.819C194.976 130.094 199.036 131.753 204.081 131.753C209.147 131.753 213.218 130.094 216.181 126.82C221.589 120.846 221.794 111.209 221.699 104.758C222.009 104.517 222.415 104.281 222.886 104.226C223.592 104.146 224.331 104.483 224.988 104.943C224.901 111.396 225.166 120.879 230.542 126.819C233.504 130.094 237.565 131.753 242.609 131.753C247.674 131.753 251.745 130.095 254.708 126.821C260.526 120.394 260.324 109.722 260.203 103.343Z",
  fill: "#212529"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M56.8702 290.537H140.464L117.243 190.086L48.7068 249.756L56.8702 290.537Z",
  fill: "#F2D661"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M148.182 182.783C146.226 166.984 139.731 151.98 122.105 151.98C84.8799 151.98 49.614 200.52 26.5387 239.87C3.46342 279.22 20.8791 290.537 20.8791 290.537H40.9069L51.8723 284.101L73.7048 271.287L116.164 225.904L125.37 242.226L146.921 218.899C146.921 218.899 150.358 200.35 148.182 182.783Z",
  fill: "#FFEB8A"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M31.546 290.537C31.546 290.537 17.1778 275.685 31.546 263.433C45.9135 251.18 61.1516 243.876 72.2543 255.893V272.639L63.3291 290.537H31.546Z",
  fill: "#FCD6BE"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask0_147_7373",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 290,
  width: 458,
  height: 31
}, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M458 290.536V320.999H0L0 290.536H458V290.536Z",
  fill: "white"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_147_7373)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M448.128 320.999H9.87132C4.41987 320.999 0 316.215 0 310.315L0 290.536H458V310.315C458 316.215 453.58 320.999 448.128 320.999Z",
  fill: "#E9ECEF"
}))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M104.907 290.537H340.012V285.11H104.907V290.537Z",
  fill: "#212529"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M335.736 120.472H109.183C106.822 120.472 104.907 122.545 104.907 125.101V285.111H340.012V125.101C340.012 122.545 338.098 120.472 335.736 120.472Z",
  fill: "#E9ECEF"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M234.938 210.342C234.938 217.802 229.351 223.849 222.46 223.849C215.568 223.849 209.981 217.802 209.981 210.342C209.981 202.882 215.568 196.835 222.46 196.835C229.351 196.835 234.938 202.882 234.938 210.342Z",
  fill: "white"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M225.96 188.177C224.531 189.724 223.524 191.554 222.933 193.5C222.932 193.503 222.93 193.506 222.929 193.508C222.48 194.778 222.093 193.973 221.941 193.508C221.941 193.508 221.939 193.514 221.938 193.518C221.465 192.17 220.734 190.904 219.73 189.818C218.401 188.378 216.781 187.444 215.075 187.013C214.736 186.928 214.428 187.262 214.507 187.627C214.905 189.474 215.768 191.228 217.098 192.667C218.543 194.233 220.332 195.2 222.202 195.573C222.372 195.608 222.547 195.607 222.718 195.574C225.142 195.106 227.464 193.861 229.337 191.832C231.029 190.001 232.132 187.773 232.648 185.426C232.759 184.92 232.346 184.472 231.879 184.593C229.71 185.152 227.652 186.346 225.96 188.177Z",
  fill: "white"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M47.0019 290.537C47.0019 290.537 41.9957 282.519 56.5804 275.685C71.1651 268.853 96.1991 273.343 96.1991 290.537H47.0019Z",
  fill: "#B1B1B1"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M72.2541 255.892C78.6762 262.844 94.6745 274.599 91.1924 279.148C87.7096 283.697 72.2541 272.639 72.2541 272.639C72.2541 272.639 69.6245 279.628 59.6197 274.476C49.6142 269.323 52.8797 268.069 52.8797 268.069L72.2541 255.892Z",
  fill: "#FCD6BE"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M458 308.797V290.537H0.00012207L446.726 321C452.952 321 458 315.537 458 308.797Z",
  fill: "#3C3C3B",
  fillOpacity: 0.1
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M91.6835 45.7115C90.5102 45.7115 89.339 45.2006 88.4813 44.1922L68.8248 21.101C67.1955 19.1864 67.3068 16.2055 69.0764 14.4411C70.843 12.6791 73.5977 12.7988 75.2278 14.7134L94.8843 37.8054C96.5136 39.72 96.4008 42.7017 94.6327 44.4645C93.7963 45.2989 92.7388 45.7115 91.6835 45.7115Z",
  fill: "#495057"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M71.1841 90.1502C70.6474 90.1502 70.1015 90.0421 69.5723 89.8135L9.25181 63.7555C7.01862 62.79 5.93061 60.0484 6.82191 57.6312C7.71244 55.2148 10.2407 54.0363 12.4792 55.001L72.7997 81.059C75.0329 82.0246 76.1209 84.7662 75.2296 87.1834C74.5495 89.0279 72.9141 90.1502 71.1841 90.1502Z",
  fill: "#495057"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M41.0207 135.984C38.9141 135.984 37.0621 134.326 36.7243 132.002C36.3515 129.432 37.974 127.019 40.3482 126.615L66.7881 122.112C69.17 121.711 71.3925 123.465 71.7654 126.036C72.139 128.607 70.5172 131.019 68.1415 131.424L41.7031 135.926C41.4728 135.965 41.2448 135.984 41.0207 135.984Z",
  fill: "#495057"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M295.989 31.1033C295.087 31.1033 294.179 30.8013 293.4 30.1757C291.467 28.6259 291.063 25.6739 292.495 23.5834L307.344 1.90518C308.777 -0.185231 311.506 -0.621801 313.434 0.926411C315.366 2.4771 315.771 5.42827 314.338 7.51869L299.491 29.197C298.636 30.4439 297.321 31.1033 295.989 31.1033Z",
  fill: "#495057"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M325.213 64.563C323.667 64.563 322.17 63.6692 321.382 62.0954C320.236 59.8069 321.02 56.9465 323.134 55.7062L374.945 25.3097C377.061 24.071 379.701 24.9194 380.847 27.207C381.993 29.4955 381.208 32.3559 379.094 33.5963L327.284 63.9927C326.624 64.3789 325.914 64.563 325.213 64.563Z",
  fill: "#495057"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M369.623 103.324C369.386 103.324 369.147 103.302 368.906 103.259L343.654 98.7311C341.282 98.3053 339.678 95.879 340.07 93.3116C340.464 90.7441 342.707 89.0028 345.078 89.4328L370.33 93.9611C372.702 94.3861 374.306 96.8124 373.913 99.3806C373.56 101.687 371.715 103.324 369.623 103.324Z",
  fill: "#495057"
})));
export default SvgNotAuthorized;